import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import PlanUsersList from '../../../BusinessOverview/Plans/Containers/PlanUsersList';
import SohoFrameworkTestKeys from '../../../Utils/SohoFrameworkTestKeys';
import SelectionList from '../SelectionList';

import styles from './UsersCard.Styles';

const DEFAULT_NUMBER_OF_SHOWN_USERS = 5;

function UsersCard({
  users,
  unassignedUsers,
  onRemovePress,
  onAddUsersPress,
  onSelectPress,
  images,
  withRemoveUser,
  renderButtonsSection,
  selectAllButtonTitle,
  removeButtonTitle,
  confirmButtonTitle,
  showMoreButtonTitle,
  showLessButtonTitle,
  assignedUsersTitle,
  unAssignedUsersTitle,
  assignedUsersEmptyText,
  unAssignedUsersEmptyText,
  ...props
}) {
  const theme = useTheme();

  return (
    <View style={styles.containerStyle(theme)}>
      <PlanUsersList
        users={users}
        onRemovePress={onRemovePress}
        images={images}
        withRemoveUser={withRemoveUser}
        removeButtonTitle={removeButtonTitle}
        title={assignedUsersTitle}
        emptyText={assignedUsersEmptyText}
      />

      <SelectionList
        title={unAssignedUsersTitle}
        dataConfig={{
          data: unassignedUsers,
          dataTitleKey: 'name',
          dataSubTitleKey: 'phoneNumber',
          defaultNumberOfShownData: DEFAULT_NUMBER_OF_SHOWN_USERS,
        }}
        testKeys={{
          selectionTitleTestKey: SohoFrameworkTestKeys.PlanUserNameTitle,
          selectTestKey: SohoFrameworkTestKeys.PlanCBUnassignedUser,
          titleTestKey: SohoFrameworkTestKeys.PlanNumberOfUnAssignedUsersInPlanTitle,
          primaryButtonTestKey: SohoFrameworkTestKeys.PlanConfirmAddUsersBtn,
        }}
        images={images}
        withSelect={true}
        withShowMore={true}
        selectAllButtonTitle={selectAllButtonTitle}
        primaryButtonTitle={confirmButtonTitle}
        showMoreButtonTitle={showMoreButtonTitle}
        showLessButtonTitle={showLessButtonTitle}
        renderButtonsSection={renderButtonsSection}
        onPrimaryButtonPress={onAddUsersPress}
        onSelectPress={onSelectPress}
        emptyText={unAssignedUsersEmptyText}
      />
    </View>
  );
}

UsersCard.defaultProps = {
  withRemoveUser: true,
};

UsersCard.propTypes = {
  users: PropTypes.array,
  unassignedUsers: PropTypes.array,
  onRemovePress: PropTypes.func,
  onSelectPress: PropTypes.func,
  onAddUsersPress: PropTypes.func,
  images: PropTypes.object,
  withRemoveUser: PropTypes.bool,
  renderButtonsSection: PropTypes.func,
  selectAllButtonTitle: PropTypes.string,
  showMoreButtonTitle: PropTypes.string,
  showLessButtonTitle: PropTypes.string,
  removeButtonTitle: PropTypes.string,
  confirmButtonTitle: PropTypes.string,
  assignedUsersTitle: PropTypes.string.isRequired,
  unAssignedUsersTitle: PropTypes.string.isRequired,
  assignedUsersEmptyText: PropTypes.string,
  unAssignedUsersEmptyText: PropTypes.string,
};

export default UsersCard;
